function hyphensToCamel(string) {
    const camelCased = string.replace(/-([a-z])/g, function(g) {
        return g[1].toUpperCase();
    });
    return camelCased;
}

function _getString(selector, settingName) {
    const el = document.querySelector(selector);
    if (el !== null) return el.dataset[settingName];
    return null;
}

function _stringToObj(string) {
    const settingsArr = string?.split(',');
    if (settingsArr === undefined) return [];
    const arrOfObj = settingsArr.map(setting => {
        const split = setting.split(':');
        const key = split[0].trim();
        let val = split[1].trim();
        if (val === 'true') val = true;
        if (val === 'false') val = false;
        const obj = {};
        const keyCamel = hyphensToCamel(key);
        obj[keyCamel] = val;
        return obj;
    });
    return arrOfObj;
}

function arrToObj(arr) {
    const obj = Object.assign(
        {},
        ...arr.map(s => {
            const key = Object.keys(s)[0];
            const val = s[key];
            const o = {};
            o[key] = val;
            return o;
        })
    );
    if (typeof obj === 'object' && obj !== null) return obj;
    return 'For some reason the result is not an object, check the page settings module';
}

export default function(settingName) {
    if (settingName) {
        const string = _getString('body', settingName);
        const arr = _stringToObj(string);
        return arrToObj(arr);
    }
    return null;
}
